import { useEffect, useState } from "react";
import { req } from "./ServerUtils";
import { TextField } from '@mui/material';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

export function UserConsole({}) {
    const [email, setEmail] = useState("");
    const [profile, setProfile] = useState(null);
    const [users, setUsers] = useState(null);

    function setAsDesigner(isDesigner) {
        req("/admin/set_is_designer", "POST", JSON.stringify({email, is_designer: isDesigner}))
    }

    function fetchProfile() {
        req("/admin/profile", "POST", JSON.stringify({email})).then((res) => {
            setProfile(res)
        })
    }

    // Function to format the date string
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const options = { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
        return date.toLocaleString('en-US', options).replace(',', '');
    };


    return (
        <div style={{
            padding: 40,
        }}>
            <div style={{
                
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                alignItems: "center",
                gap: 20
            }}>
                <TextField value={email} onChange={(e) => setEmail(e.target.value)} label="Email" />
                <Button variant="outlined" onClick={() => setAsDesigner(true)}>Add Designer Perm</Button>
                <Button variant="outlined" onClick={() => setAsDesigner(false)}>Delete Designer Perm</Button>

                <Button variant="outlined" onClick={fetchProfile}>See Profile</Button>
            </div>
            <div>
                {profile && <pre>
                    {JSON.stringify(profile, null, 4)}
                    </pre>}
            </div>
            <div>
            
                <UsersList />
            </div>
            
        </div>

    )
}

function UsersList({}) {
    const [users, setUsers] = useState([]);


    function fetchUsers() {
        req("/admin/users", "GET").then((res) => {
            setUsers(res)
        })
    }

    // Function to format the date string
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const options = { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
        return date.toLocaleString('en-US', options).replace(',', '');
    };
    const skip = ['is_verified', 'profile_pic_cropped', 'profile_pic_uncropped']

    return (
        <div style={{ padding: '10px' }}>
            <Button variant="contained" onClick={fetchUsers} style={{ marginBottom: '10px' }}>
                Fetch Users
            </Button>

            {users.length > 0 ? (
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                {Object.keys(users[0]).map((key) => !skip.includes(key) && (
                                    <TableCell key={key} style={{ fontWeight: 'bold' }}>
                                        {key}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((user, index) => (
                                <TableRow key={index}>
                                    {Object.entries(user).map(([key, value], i) => !skip.includes(key) && (
                                        <TableCell key={i} style={{
                                            padding:0,
                                            maxWidth: key == "permissions" ? 200 : "auto",
                                            overflow: "wrap",
                                        }}>
                                            {key === 'created_at' ? formatDate(value) : value !== null ? value.toString() : 'N/A'}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <div>No users found. Click "Fetch Users" to load data.</div>
            )}
        </div>
    );
}
